// analytics.js — PostHog wrapper
// Requires REACT_APP_POSTHOG_KEY in your .env file.
// If the key is absent, all calls are silent no-ops (safe for local dev).
import posthog from 'posthog-js';

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.posthog.com';

export function initAnalytics() {
  if (!KEY) return;
  // Skip during react-snap pre-rendering (headless Chromium can't run posthog-js)
  if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') return;
  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: true,
    autocapture: true,
    persistence: 'localStorage+cookie',
    respect_dnt: true,
  });
}

export function track(event, properties = {}) {
  if (!KEY) return;
  posthog.capture(event, properties);
}

export function identify(userId, traits = {}) {
  if (!KEY) return;
  posthog.identify(userId, traits);
}
